import { gql } from '@apollo/client';

export default gql`
  mutation($password: String!, $salt: String!) {
    resetIssuerAdmin(password: $password, salt: $salt)
  }
`;
